module.exports = __webpack_public_path__ + "img/post_box.e8677853.svg";